import { render } from "./UserPage_loan_secondSemester.vue?vue&type=template&id=49cff239&scoped=true"
import script from "./UserPage_loan_secondSemester.vue?vue&type=script&lang=js"
export * from "./UserPage_loan_secondSemester.vue?vue&type=script&lang=js"

import "./UserPage_loan_secondSemester.vue?vue&type=style&index=0&id=49cff239&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cff239"]])

export default __exports__